module.exports = __webpack_public_path__ + "f296a4d8417266f049ec3807752ccdf9.svg";